import {Routes} from '@angular/router'
import {authGuard} from './application/auth.guard'
import {LoginComponent} from './components/login/login.component'
import {HomeComponent} from './kyc/home/home.component'

export const routes: Routes = [
  {
    path: 'fyll-i',
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [authGuard]
      },
      {
        path: ':step',
        component: HomeComponent,
        canActivate: [authGuard]
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: 'login'
  }
]